import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faHeart } from '@fortawesome/free-solid-svg-icons';
import defaultUserPhoto from '../../../images/default_user.png';
import { favStatuses } from '../../../constants/workers';
import { workerBusyMessage } from '../../../constants/text';

export default class WorkerItemForSelection extends Component {
  static propTypes = {
    worker: PropTypes.object.isRequired,
    isSelected: PropTypes.bool.isRequired,
    handleWorkerSelection: PropTypes.func.isRequired
  };

  render () {
    const { worker, isSelected, handleWorkerSelection } = this.props;
    const { photo_image_url, first_name, last_name, status, fav_status, is_hired_at_date } = worker;
    const fullName = first_name + ' ' + last_name;
    const isFavorite = status === favStatuses.favorite || fav_status === favStatuses.favorite;
    return (
      <div className='d-flex align-items-center my-3'>
        <div className='photo-wrapper mr-2'>
          <div
            className='worker-photo'
            style={{ backgroundImage: `url('${photo_image_url || defaultUserPhoto}')` }}
          />
          { isFavorite && (
            <span className='heart-icon'>
              <FontAwesomeIcon icon={faHeart} />
            </span>
          )}
        </div>
        <div className='worker-info'>
          <h5>{fullName}</h5>
          { is_hired_at_date && <p>{ workerBusyMessage }</p> }
        </div>
        <button
          type='button'
          className={`select-worker-checkbox ${isSelected ? 'active' : ''}`}
          onClick={() => handleWorkerSelection(worker)}
        >
          { isSelected && <FontAwesomeIcon icon={faCheck} />}
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ui/WorkerItemForSelection.js